import { Card, CardProps } from '@mui/material'
import { FC } from 'react'

const CardWrapper: FC<CardProps> = ({ ...props }) => <Card {...props} />

export default CardWrapper
